// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Answer-module__pageContainer--PStLV {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: center;
    align-items: center;
    height: 70vh;
}

.Answer-module__answerBox--H8Lw2 {
    display: flex;
    flex-direction: column;
    width: 70%;
    align-items: center;
    text-align: center;
    padding: 20px;
}

.Answer-module__iconBox--_PDfn {
    display: flex;
    margin-bottom: 20px;
}
.Answer-module__iconBox--_PDfn > svg {
    color: green;
    width: 100px;
    height: 100px;
}

.Answer-module__answerTitle--Zr1JK {
    color: #325572;
    font-size: 30px;
    margin-bottom: 15px;
}

.Answer-module__numberTask--cMibM {
    color: #0054E6;
    font-size: 16px;
    font-weight: bold;
}

.Answer-module__btnBox--bx2xB {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 30px;
    gap: 15px;
}

.Answer-module__btnBack--hND_H {
    text-transform: none !important;
    display: flex;
    align-items: center;
    height: 70px;
    gap: 10px;
    color: #0054E6;
}`, "",{"version":3,"sources":["webpack://./src/features/create-task/ui/Answer.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,SAAS;IACT,cAAc;AAClB","sourcesContent":[".pageContainer {\r\n    display: flex;\r\n    align-items: center;\r\n    width: 100%;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 70vh;\r\n}\r\n\r\n.answerBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 70%;\r\n    align-items: center;\r\n    text-align: center;\r\n    padding: 20px;\r\n}\r\n\r\n.iconBox {\r\n    display: flex;\r\n    margin-bottom: 20px;\r\n}\r\n.iconBox > svg {\r\n    color: green;\r\n    width: 100px;\r\n    height: 100px;\r\n}\r\n\r\n.answerTitle {\r\n    color: #325572;\r\n    font-size: 30px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.numberTask {\r\n    color: #0054E6;\r\n    font-size: 16px;\r\n    font-weight: bold;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    margin-top: 30px;\r\n    gap: 15px;\r\n}\r\n\r\n.btnBack {\r\n    text-transform: none !important;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 70px;\r\n    gap: 10px;\r\n    color: #0054E6;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContainer": `Answer-module__pageContainer--PStLV`,
	"answerBox": `Answer-module__answerBox--H8Lw2`,
	"iconBox": `Answer-module__iconBox--_PDfn`,
	"answerTitle": `Answer-module__answerTitle--Zr1JK`,
	"numberTask": `Answer-module__numberTask--cMibM`,
	"btnBox": `Answer-module__btnBox--bx2xB`,
	"btnBack": `Answer-module__btnBack--hND_H`
};
export default ___CSS_LOADER_EXPORT___;
